export interface Employer {
  EmployerName: string;
  EmployerAddress: string;
  EmployerNationality: string;
  EmployerCity: string;
  EmployerState: string;
  EmployerZipCode: string;
}
